<nav id="nav-header" class="header-background-color header" [ngClass]="environment !== '' ? environment + '-background-color' : ''">
  <div class="logo" (click)="gotoDashboard.emit()">
    <img src="../assets/img/logo-mobile.png" *ngIf="showSmallLogo$ | async; else bigLogo"/>
    <ng-template #bigLogo><img src="../assets/img/logo.png"/></ng-template>
    <span>{{ environment }}</span>
  </div>

  <div class="right">
    <!-- begin main menu -->
    <span class="modules" [@modules]="visibleModules.length">
      <a
        *ngFor="let module of visibleModules"
        [ngClass]="{ module: true, enabled: isEnabled(module), disabled: module.disabled, active: isActive(module, path) }"
        (click)="moduleClicked(module)"
        >{{ module.translationCode | translate }}</a
      >
    </span>
    <!-- end main menu -->

    <span class="modules" [@modules]="authorized !== false" *ngIf="loggedIn">
      <a [ngClass]="{ enabled: loggedIn }" class="more_ellipsis" [matMenuTriggerFor]="headerMenu" *ngIf="authorized !== false">
        {{ 'SHARED.HEADER.MORE' | translate }}
      </a>
    </span>

    <!-- begin dropdown menu user -->
    <mat-menu #headerMenu="matMenu" [overlapTrigger]="false">
      <button
        mat-menu-item
        *ngFor="let module of visibleHeaderModules"
        [ngClass]="{ enabled: isEnabled(module), disabled: module.disabled, active: isActive(module, path) }"
        (click)="moduleClicked(module)"
        type="button"
      >
        <span>{{ module.translationCode | translate }}</span>
      </button>
    </mat-menu>
    <!-- end dropdown menu user -->

    <div class="usermenu-container">
      <!-- LOGGED IN & ACTIVE CUSTOMER -->
      <a class="usermenu" @usermenu [matMenuTriggerFor]="menuLoggedIn" *ngIf="loggedIn && selectedCustomer && selectedCustomer.id && !contractDetailsLoading">
        <div class="user-container">
          <span class="initials">{{ initials }}</span>
          <div *ngIf="!userContext.isSuperUser" class="userInfo">
            <span class="loggedAs">{{ selectedCustomer?.id }}</span>
            <span class="customer">{{ selectedCustomer?.name }}</span>
          </div>
        </div>
      </a>

      <!-- LOGGED IN & NO ACTIVE CUSTOMER -->
      <a @usermenu class="usermenu" [matMenuTriggerFor]="menuLoggedIn" *ngIf="loggedIn && (!selectedCustomer || !selectedCustomer.id) && !contextLoading && !contractDetailsLoading">
        <div class="user-container">
          <span class="initials">{{ initials }}</span>
          <div class="userInfo">
            <span class="loggedAs">{{ 'SHARED.HEADER.WELCOME' | translate }}</span>
            <span class="customer">{{ firstName }}</span>
          </div>
        </div>
      </a>

      <!-- LOGGED IN & LOADING CONTEXT or CONTRACT-->
      <a @usermenu class="usermenu" *ngIf="contextLoading || contractDetailsLoading">
        <div class="user-container">
          <i class="fa fa-spinner fa-pulse fa-fw"></i>
          {{ 'SHARED.HEADER.' + (contextLoading ? 'LOADING_CONTEXT' : 'LOADING_CONTRACT') | translate }}
        </div>
      </a>

      <!-- LOGGED OUT -->
      <a @usermenu class="usermenu enabled login" *ngIf="!loggedIn && !contextLoading && !contractDetailsLoading && authorized !== false">
        <span (click)="login.emit()">{{ 'SHARED.HEADER.LOGIN' | translate }}</span>
      </a>

      <!-- LOGGED OUT -->
      <a @usermenu class="usermenu enabled login" *ngIf="!loggedIn && !contextLoading && !contractDetailsLoading && authorized === false">
        <span (click)="logout.emit()">{{ 'SHARED.HEADER.LOGOUT' | translate }}</span>
      </a>

      <!-- USER MENU -->
      <mat-menu #menuLoggedIn="matMenu" [overlapTrigger]="false">
        <button mat-menu-item (click)="logout.emit()" type="button">
          <span>{{ 'SHARED.HEADER.LOGOUT' | translate }}</span>
        </button>
        <button mat-menu-item type="button" (click)="selectCustomer.emit()" *ngIf="selectedCustomer && canSwitchCustomer && !userContext.isSuperUser">
          <span>{{ 'SHARED.HEADER.SWITCH_CUSTOMER' | translate }}</span>
        </button>
      </mat-menu>
      <div class="mobile_menu_bars" (click)="openMobileMenu = !openMobileMenu" (clickOutside)="closeMobileMenu()" [menuOpen]="openMobileMenu">
        <i class="fa fa-bars"></i>
      </div>
      <div class="mobile_menu" *ngIf="openMobileMenu">
        <div
          *ngFor="let module of visibleMobileModules"
          [ngClass]="{ enabled: loggedIn && !module.disabled, disabled: module.disabled, active_mobile: isActive(module, path) }"
          (click)="moduleClicked(module); openMobileMenu = !openMobileMenu"
          class="mobile_menu_item"
        >
          <span>{{ module.translationCode | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</nav>
